import { connect } from 'react-redux';
import { orderSelector, statusSelector } from '../selector';
import Order from '../components/order';
import { invalidateOrder, fetchOrderStatus } from '../actions';

const mapDispatchToProps = dispatch => ({
  invalidateOrder: () => dispatch(invalidateOrder()),
  fetchOrderStatus: ({ order_id }) => dispatch(fetchOrderStatus({ order_id })),
});

const mapStateToProps = state => {
  const { fetchOrder, payOrder } = statusSelector(['fetchOrder', 'payOrder'])(
    state
  );
  return {
    fetchOrderStatus: fetchOrder,
    payOrderStatus: payOrder,
    ...orderSelector(state),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Order);



// WEBPACK FOOTER //
// ./src/containers/order.js